import styled from "styled-components";
import { Link } from "react-router-dom";

export const ListRoot = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const GroupHeading = styled.li`
  margin: 24px 0 8px;
  color: var(--ASH, #676879);
  font:
    600 11px/1.4 Inter,
    sans-serif;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  &:first-child {
    margin-top: 20px;
  }
`;

export const RecordChip = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  border-radius: 4px;
  padding: 3px 7px;
  background: var(--GHOST, #efeffd);
  color: var(--DARK-BLUE, #1249bf);
  font:
    600 11px/1.3 Inter,
    sans-serif;
`;

export const NoteCard = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 76px;
  padding: 18px 4px;
  border-bottom: 1px solid var(--PEARL, #ecf1f4);

  &:hover .entry-actions,
  &:focus-within .entry-actions {
    opacity: 1;
  }
`;

export const TaskCheckbox = styled.input`
  width: 18px;
  height: 18px;
  margin: 0;
  flex: 0 0 18px;
  accent-color: var(--BLUE, #2060ea);
  cursor: pointer;
`;

export const CardBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EntryLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const CardMain = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  color: var(--DARK-GREY, #0e0e2c);
  font:
    500 14px/1.5 Inter,
    sans-serif;
  cursor: pointer;
  overflow-wrap: anywhere;

  &.note {
    color: var(--GREY, #4a4a68);
  }
  &.struck {
    color: var(--ASH, #676879);
    text-decoration: line-through;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 3px 7px;
  border-radius: 4px;
  background: ${({ $isTask }) => ($isTask ? "var(--GHOST, #efeffd)" : "var(--MIST, #f7f8f9)")};
  color: ${({ $isTask }) => ($isTask ? "var(--DARK-BLUE, #1249bf)" : "var(--GREY, #4a4a68)")};
  font:
    600 11px/1.2 Inter,
    sans-serif;
  text-transform: uppercase;
`;

export const DueBadge = styled.span`
  padding: 4px 7px;
  border-radius: 4px;
  background: var(--BLUE, #2060ea);
  color: #fff;
  font:
    600 11px/1.2 Inter,
    sans-serif;
  text-transform: uppercase;

  &.overdue {
    background: #c64040;
  }

  &.subtle {
    margin-left: 8px;
    border: 1px solid var(--PEARL, #ecf1f4);
    background: var(--MIST, #f7f8f9);
    color: var(--GREY, #4a4a68);
  }

  &.subtle.overdue {
    border-color: #f1d3cf;
    background: #fff5f3;
    color: #a43f35;
  }
`;

export const Meta = styled.div`
  margin-top: 6px;
  color: var(--ASH, #676879);
  font:
    400 12px/1.5 Inter,
    sans-serif;
`;

export const ShipmentLink = styled(Link)`
  color: var(--BLUE, #2060ea);
  text-decoration: none;
`;

export const Actions = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  opacity: 1;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 4px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: var(--ASH, #676879);
    cursor: pointer;

    &:hover,
    &:focus-visible {
      background: var(--MIST, #f7f8f9);
    }
    svg {
      width: 16px;
      height: 16px;
    }
  }

  @media (hover: none) {
    opacity: 1;
  }
`;
